import { BackdropModule } from 'src/@dva/shared/backdrop/backdrop.module';
import { CommonModule } from '@angular/common';
import { FilterPanelModule } from './filter-panel/filter-panel.module';
import { FooterModule } from './footer/footer.module';
import { LayoutComponent } from './layout.component';
import { LoadingIndicatorModule } from 'src/@dva/shared/loading-indicator/loading-indicator.module';
import { MaterialModule } from 'src/@dva/shared/material-components.module';
import { NavigationModule } from './navigation/navigation.module';
import { NgModule } from '@angular/core';
import { ProgressPanelModule } from './progress-panel/progress-panel.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/@dva/shared.module';
import { SidenavModule } from './sidenav/sidenav.module';
import { ToolbarModule } from './toolbar/toolbar.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    LoadingIndicatorModule,
    SharedModule,
    ProgressPanelModule,
    // Core
    ToolbarModule,
    SidenavModule,
    FooterModule,
    BackdropModule,
    NavigationModule,
    FilterPanelModule,
  ],
  declarations: [LayoutComponent],
})
export class LayoutModule {}
